var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "1h7pumdnna",
    width: 42,
    height: 42,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1h7pumdnna)",
    transform: "translate(9 6) translate(-9 -6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2895ff",
    d: "M8.121 9.189a1.981 1.981 0 1 1-1.98-1.981 1.983 1.983 0 0 1 1.98 1.981zm4.16-2.813V12a1.358 1.358 0 0 1-1.358 1.358H1.358A1.358 1.358 0 0 1 0 12V6.376a1.358 1.358 0 0 1 1.358-1.358h1.67v-.47A1.188 1.188 0 0 1 4.217 3.36h3.848a1.188 1.188 0 0 1 1.188 1.188v.47h1.67a1.359 1.359 0 0 1 1.359 1.358zM9.14 9.189a3 3 0 1 0-3 3 3 3 0 0 0 3-3z",
    transform: "translate(9 6) translate(6 3.64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.0bc5095a8126233e3c583e1a9202d29d.svg";
export { ForwardRef as ReactComponent };